import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { AUTOMATION_RULES_API } from '../api/automation-rules-api';
import { AutomationRuleViewInterface } from '../types/automation-rule-interface';
export const useCreateRule = props => {
  const $ = _c(4);
  let t0;
  if ($[0] !== props) {
    t0 = {
      method: RequestMethodsEnum.post,
      ...props
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[2] !== fetcher) {
    t1 = {
      fetcher: async data => fetcher(`${AUTOMATION_RULES_API}`, data, {
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    };
    $[2] = fetcher;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};